'use client';

import { useState } from 'react';
import type { OfficialShowcaseSectionData } from '../../types';
import { OverlayCard } from './OverlayCard';
import { SplitLayout } from './SplitLayout';

export function OfficialShowcaseSection({ section }: { section: OfficialShowcaseSectionData }) {
  const tabs = section.tabs ?? [];
  const [activeIndex, setActiveIndex] = useState(0);
  const activeTab = tabs[activeIndex] ?? tabs[0];

  if (!activeTab) {
    return null;
  }

  const props = { activeIndex, activeTab, section, setActiveIndex, tabs };

  switch (section.layout) {
    case 'overlay_card':
      return <OverlayCard {...props} />;
    default:
      return <SplitLayout {...props} />;
  }
}
